export default __webpack_public_path__ + "static/media/logo.ec69c7f6.png";